// Shared helpers for BizDevToolbelt calculators. Each tool registers its own custom element.
window.BDTTools = window.BDTTools || {
  // Reads a money input, ignoring currency symbols and commas. Blank or invalid counts as 0.
  readNumber(input) {
    if (!input) return 0;
    const value = parseFloat(String(input.value).replace(/[^0-9.]/g, ''));
    return Number.isFinite(value) ? value : 0;
  },

  money(value, currency) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'USD',
        maximumFractionDigits: 0,
      }).format(value);
    } catch (e) {
      return '$' + Math.round(value).toLocaleString();
    }
  },

  percent(ratio) {
    if (!Number.isFinite(ratio)) return '—';
    return (ratio * 100).toFixed(1).replace(/\.0$/, '') + '%';
  },

  async copy(text, button) {
    let copied = false;
    try {
      await navigator.clipboard.writeText(text);
      copied = true;
    } catch (e) {
      const scratch = document.createElement('textarea');
      scratch.value = text;
      scratch.setAttribute('readonly', '');
      scratch.style.position = 'fixed';
      scratch.style.opacity = '0';
      document.body.appendChild(scratch);
      scratch.select();
      try {
        copied = document.execCommand('copy');
      } catch (err) {
        copied = false;
      }
      scratch.remove();
    }
    if (button) {
      const label = button.dataset.label || button.textContent;
      button.dataset.label = label;
      button.textContent = copied ? 'Copied' : 'Select the text and copy it';
      clearTimeout(button._bdtTimer);
      button._bdtTimer = setTimeout(() => (button.textContent = label), 2500);
    }
    return copied;
  },

  // Fires a Shopify customer event once per page view so tool usage shows up in analytics.
  track(tool, detail) {
    this._tracked = this._tracked || {};
    if (this._tracked[tool]) return;
    this._tracked[tool] = true;
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('bdt_tool_completed', Object.assign({ tool }, detail || {}));
      }
    } catch (e) {
      // Analytics should never break the tool.
    }
  },
};
